module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/public/gift/change_i.png";